module.exports = __webpack_public_path__ + "static/media/pdx-floor-3.e95864a5.png";